import {DataTypes, FormTypes} from "../types";
import {Button} from "react-bootstrap";
import api from "../../../../../../utilities/API";
import * as t from "counterpart";

const coupons = {
    //
    backend: {
        endpoint: "/commerce/coupons/"
    },

    //
    listing: {
        pk: "id",
        permission: "com.coupons.list",
        columns: [
            {attribute: "id", clickable: true, modifier: (v) => "#"+v, props: {className: "col-md-1"},},
            {attribute: "name", clickable: true, props: {className: "col-md-2"}},
            {attribute: "capacity", props: {className: "col-md-2"}},
            {attribute: "usage", props: {className: "col-md-1"}},
            {attribute: "date_from", props: {className: "col-md-2"}},
            {attribute: "date_to", props: {className: "col-md-2"}},
            {attribute: "active", props: {className: "col-md-1"}}
        ],
    },

    creating: {
        permission: "com.coupons.create"
    },

    editing: {
        permission: "com.coupons.update"
    },

    deleting: {
        permission: "com.coupons.delete"
    },

    //
    form: {
        buttons: [
            ({entity}) =>
                entity.id ? <Button key={1} style={{margin: "0 5px"}} onClick={() => api(`/commerce/coupons/${entity.id}/orders`, {blob: true, error: alert})}>
                    <i className="fas fa-download" /> {t("Export")}
                </Button> : null,
        ],

        layout: [
            {
                className: "col-md-8",
                elements: [
                    {attribute: "name", type: FormTypes.TextInput, className: "col-md-6"},
                    {attribute: "coupon_code", type: FormTypes.TextInput, className: "col-md-6"},
                    {divider: true},
                    {attribute: "capacity", type: FormTypes.TextInput, className: "col-md-4"},
                    {attribute: "use_per_user", type: FormTypes.TextInput, className: "col-md-4"},
                    {attribute: "order_amount", type: FormTypes.TextInput, className: "col-md-4"},
                    {attribute: "percent", type: FormTypes.Checkbox, className: "col-md-12"},
                    {attribute: "discount", type: FormTypes.TextInput, className: "col-md-4"},
                    {attribute: "minimum", type: FormTypes.TextInput, className: "col-md-4"},
                    {attribute: "maximum", type: FormTypes.TextInput, className: "col-md-4"},
                    {attribute: "description", type: FormTypes.Textarea, wysiwyg: true, className: "col-md-12"},
                ]
            },
            {
                className: "col-md-4",
                elements: [
                    {attribute: "date_from", type: FormTypes.Datepicker, className: "col-md-12"},
                    {attribute: "date_to", type: FormTypes.Datepicker, className: "col-md-12"},
                    {divider: true},
                    {attribute: "included_tags", type: FormTypes.Select, addItem: true, className: "col-md-12"},
                    {attribute: "excluded_tags", type: FormTypes.Select, addItem: true, className: "col-md-12"},
                    {divider: true},
                    {attribute: "products_ids", type: FormTypes.Select, className: "col-md-12"},
                    {attribute: "customer_id", type: FormTypes.Select, className: "col-md-12"},
                    {divider: true},
                    {attribute: "disable_gifts", type: FormTypes.Checkbox, className: "col-md-6"},
                    {attribute: "active", type: FormTypes.Checkbox, className: "col-md-6"},
                ]
            }
        ]
    },

    //
    attributes: {
        id: {
            type: DataTypes.Integer,
        },
        name: {
            type: DataTypes.Text,
        },
        coupon_code: {
            type: DataTypes.Integer,
        },
        capacity: {
            type: DataTypes.Integer,
            label: "Number of coupons"
        },
        discount: {
            type: DataTypes.Integer,
        },
        percent: {
            type: DataTypes.Boolean,
        },
        minimum: {
            type: DataTypes.Integer,
        },
        Maximum: {
            type: DataTypes.Integer,
        },
        order_amount: {
            type: DataTypes.Integer,
        },
        use_per_user: {
            type: DataTypes.Integer,
        },
        date_from: {
            type: DataTypes.DateTime,
        },
        date_to: {
            type: DataTypes.DateTime,
        },
        disable_gifts: {
            type: DataTypes.Boolean,
        },
        active: {
            type: DataTypes.Boolean,
        },
        usage: {
            type: DataTypes.Integer,
            label: "Number of Usage"
        },
        included_tags: {
            type: DataTypes.Array,
        },
        excluded_tags: {
            type: DataTypes.Array,
        },
        customer_id: {
            type: DataTypes.Integer,
            relation: {
                entity: "system.users",
                idAttr: "id",
                nameAttr: "full_name",
                dataAttr: "customer",
            }
        },
        products_ids: {
            type: DataTypes.Array,
            relation: {
                type: "m2m",
                entity: "commerce.products",
                idAttr: "id",
                nameAttr: "name",
                filterAttr: "search",
                dataAttr: "products",
            }
        },
        description: {
            type: DataTypes.Text,
        },
        updated_at: {
            type: DataTypes.DateTime,
        }
    },
};

export default coupons;
